import React, { ReactNode } from "react";

import Lottie from "lottie-react";
import ToolsAnimation from "../assets/tools.json";
import { useQuery } from "react-query";
import { checkBackendHealth } from "../services";
import { useTranslation } from "react-i18next";
import Button from "./button";
import { ButtonSize, ButtonVariant } from "./button/types";

const healthQueryKey = ["backendHealth"];

interface MaintenanceWrapperProps {
  children: ReactNode;
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({
  children,
}) => {
  const { t } = useTranslation("common");
  const {
    data: healthStatus,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: healthQueryKey,
    queryFn: checkBackendHealth,
    retry: 1,
    refetchOnWindowFocus: false,
  });

  // 2. Show Maintenance Page if query resulted in an error
  if (isError) {
    console.error("Maintenance Mode Triggered:", error);
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
        <div className="w-full max-w-md mx-auto md:max-w-lg p-8 bg-white shadow-lg rounded-xl">
          <h1 className="text-3xl md:text-4xl font-semibold mb-12 text-center">
            {t("maintenance.title")}
          </h1>
          <div className="w-56 h-56 md:w-56 md:h-56 mx-auto mb-12">
            <Lottie animationData={ToolsAnimation} loop={true} />
          </div>
          <p className="text-base md:text-lg max-w-md mx-auto leading-relaxed text-gray-700 mb-6 text-center">
            {t("maintenance.message")}
          </p>

          <div className="mt-4 flex justify-center">
            <Button
              variant={ButtonVariant.SECONDARY}
              size={ButtonSize.SMALL}
              onClick={() => window.location.reload()}
            >
              {t("maintenance.tryAgain")}
            </Button>
          </div>

          {/* Error details (development only) */}
          {/* {error instanceof Error && process.env.NODE_ENV === "development" && (
            <div className="mt-8 p-4 bg-red-50 rounded-md border border-red-100">
              <p className="text-xs font-mono text-red-600 max-w-xl break-words text-left">
                <span className="font-semibold">Error:</span> {error.message}
              </p>
            </div>
          )} */}
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default MaintenanceWrapper;
